/**
 * SENTO Anti-Copy — Lightweight Content Protection
 * Scope: Product images, collection card images, hero images
 * Safe zones: FAQ, Contact, policy pages, form inputs, text search (Ctrl+F)
 * Does NOT block: Googlebot, normal text selection, checkout, cart, PayPal
 */
(function () {
  'use strict';

  // ── Image selectors to protect ────────────────────────────────────────────
  var IMG_SELECTORS = [
    '.product__media img',
    '.product-media img',
    '.product__media-item img',
    '.card__media img',
    '.card__media picture img',
    '.product-card img',
    '.collection img',
    '.media img',
    '.sento-hero img',
    '.banner__media img',
    '.slideshow__media img',
    '.deferred-media img',
  ].join(', ');

  // ── Pages where text copy must remain fully unlocked ─────────────────────
  var SAFE_PATH_PATTERNS = [
    /\/pages\/faq/i,
    /\/pages\/contact/i,
    /\/policies\//i,
    /\/pages\/privacy/i,
    /\/pages\/shipping/i,
    /\/pages\/refund/i,
    /\/pages\/terms/i,
    /\/checkouts?\//i,
    /\/cart/i,
    /\/account/i,
  ];

  function isSafePage() {
    var path = window.location.pathname;
    return SAFE_PATH_PATTERNS.some(function (re) { return re.test(path); });
  }

  function isProductPage() {
    return /\/products\//i.test(window.location.pathname);
  }

  // ── Bind image protections ─────────────────────────────────────────────────
  function protectImages() {
    document.querySelectorAll(IMG_SELECTORS).forEach(function (img) {
      // Right-click block
      img.addEventListener('contextmenu', function (e) {
        e.preventDefault();
        return false;
      }, true);

      // Drag block
      img.addEventListener('dragstart', function (e) {
        e.preventDefault();
        return false;
      }, true);

      // Pointer events: allow clicks, block drag gesture on touch
      img.setAttribute('draggable', 'false');
    });
  }

  // ── MutationObserver: re-apply on dynamically loaded content ─────────────
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.addedNodes.length) protectImages();
    });
  });

  // ── Copy event: append source attribution on product pages ───────────────
  function attachCopyAttribution() {
    if (isSafePage()) return; // Never touch safe pages
    if (!isProductPage()) return; // Only product pages

    document.addEventListener('copy', function (e) {
      // Skip if selection is inside input / textarea / editable element
      var activeEl = document.activeElement;
      if (activeEl && (
        activeEl.tagName === 'INPUT' ||
        activeEl.tagName === 'TEXTAREA' ||
        activeEl.isContentEditable
      )) return;

      var selection = window.getSelection ? window.getSelection() : null;
      if (!selection || selection.toString().trim().length < 20) return; // Too short, skip

      try {
        var original = e.clipboardData.getData('text/plain') || selection.toString();
        var appended = original + '\n\nSource: SENTO — gosento.store';
        e.clipboardData.setData('text/plain', appended);
        e.preventDefault();
      } catch (err) {
        // Silent fail — never break copy for user
      }
    });
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    protectImages();
    attachCopyAttribution();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
